<div class="field">
  <label class="weight-medium is-uppercase">{{ label }}</label>
  <div class="control" [formGroup]="form">
    <div
      class="select is-fullwidth has-text-warning"
      [class.is-medium]="size === 'medium'"
      [class.no-border]="noBorder"
      [class.is-tall]="size === 'tall'"
      [ngClass]="{ 'is-danger': submitted && getControl().errors?.required }"
    >
      <select
        [id]="id"
        [class.is-disabled]="disabled"
        [formControlName]="inputName"
        [value]="value"
        (change)="changeOption.emit(true)"
      >
        <option *ngIf="!isSegment" value="" [disabled]="placeholderDisabled">
          {{ placeholder }}
        </option>

        <ng-container *ngFor="let item of values; let i = index">
          <option
            *ngIf="!isSegment && translate && !simple && !affectationAvailable"
            [disabled]="item.isAvailableAffectation || item?.isDisabled"
            [value]="item.code"
          >
            {{ 'select-inputs.' + item.name | translate }}
          </option>

          <option
            *ngIf="!isSegment && translate && !simple && affectationAvailable"
            [disabled]="item?.isDisabled"
            [value]="item.code"
          >
            {{ 'select-inputs.' + item.name | translate }}
          </option>

          <option *ngIf="!isSegment && !translate && !simple" [value]="item.code">
            {{ item.name }}
          </option>
          <option *ngIf="isSegment" [value]="item">
            {{
              '# ' +
                (i + 1) +
                ' : ' +
                item.departureLocation.code +
                '/' +
                item.departureLocation.name +
                ' ---> ' +
                item.arrivalLocation.code +
                '/' +
                item.arrivalLocation.name
            }}
          </option>

          <option *ngIf="simple && !time" [value]="item">
            {{ item }}
          </option>

          <option *ngIf="simple && time" [value]="item">
            {{ item | date : 'HH:mm' }}
          </option>
        </ng-container>
      </select>
    </div>
    <p *ngIf="submitted && getControl().errors?.required" class="help is-danger">
      {{ errorMessage }}
    </p>
  </div>
</div>
